import { DEFAULT_THEME, isAppTheme, type AppTheme } from "./catalog";

export const THEME_STORAGE_KEY = "bacteria-ng.theme";

export type { AppTheme };

export function normalizeTheme(value: string | null | undefined): AppTheme {
  if (isAppTheme(value)) {
    return value;
  }
  return DEFAULT_THEME;
}

export function readStoredTheme(): AppTheme {
  if (typeof window === "undefined") {
    return DEFAULT_THEME;
  }
  return normalizeTheme(localStorage.getItem(THEME_STORAGE_KEY));
}

export function writeStoredTheme(theme: AppTheme): void {
  localStorage.setItem(THEME_STORAGE_KEY, theme);
}
